export enum ETargetAccountStatus {
  ACTIVATING = 'ACTIVATING',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}
